export class SignRuleEntity{
    id: string;
    conclusionValue: string;
    conclusionName: string;
    calculateType?: string; // 计算方式
    conditionValue?: string; // 满足所有条件值
    waitAllVotes?: boolean; // 是否等待所有选票
    completionCondition: string;
}
